export default __webpack_public_path__ + "static/media/180.41f3356a.png";